import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  tags: []
};

export default {
  state,
  actions,
  mutations,
  getters
};
